/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolFileResponse,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingCountByAnalysisTypeRequest,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingCountByAnalysisTypeResponse,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingsOverTimeCsvRequest,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingsOverTimeRequest,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingsOverTimeResponse,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopAssetCsvRequest,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopAssetDataRequest,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopAssetDataResponse,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopChannelCsvRequest,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopChannelDataRequest,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopChannelDataResponse,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopDomainCsvRequest,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopDomainDataRequest,
  PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopDomainDataResponse,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class PerformanceDetailsEnfAnalysisPiracy<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags PerformanceDetailsEnfAnalysisPiracy
   * @name PiracyDetailsEnfAnalysisCreate
   * @request POST:/performance/piracy/details/enf-analysis
   */
  piracyDetailsEnfAnalysisCreate = (
    data: PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingsOverTimeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingsOverTimeResponse, any>({
      path: `/performance/piracy/details/enf-analysis`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsEnfAnalysisPiracy
   * @name PiracyDetailsEnfAnalysisCountCreate
   * @request POST:/performance/piracy/details/enf-analysis/count
   */
  piracyDetailsEnfAnalysisCountCreate = (
    data: PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingCountByAnalysisTypeRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingCountByAnalysisTypeResponse, any>({
      path: `/performance/piracy/details/enf-analysis/count`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsEnfAnalysisPiracy
   * @name PiracyDetailsEnfAnalysisTopDomainCreate
   * @request POST:/performance/piracy/details/enf-analysis/top-domain
   */
  piracyDetailsEnfAnalysisTopDomainCreate = (
    data: PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopDomainDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopDomainDataResponse, any>({
      path: `/performance/piracy/details/enf-analysis/top-domain`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsEnfAnalysisPiracy
   * @name PiracyDetailsEnfAnalysisTopChannelCreate
   * @request POST:/performance/piracy/details/enf-analysis/top-channel
   */
  piracyDetailsEnfAnalysisTopChannelCreate = (
    data: PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopChannelDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopChannelDataResponse, any>({
      path: `/performance/piracy/details/enf-analysis/top-channel`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsEnfAnalysisPiracy
   * @name PiracyDetailsEnfAnalysisTopAssetCreate
   * @request POST:/performance/piracy/details/enf-analysis/top-asset
   */
  piracyDetailsEnfAnalysisTopAssetCreate = (
    data: PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopAssetDataRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopAssetDataResponse, any>({
      path: `/performance/piracy/details/enf-analysis/top-asset`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsEnfAnalysisPiracy
   * @name PiracyDetailsEnfAnalysisTopDomainCsvCreate
   * @request POST:/performance/piracy/details/enf-analysis/top-domain/csv
   */
  piracyDetailsEnfAnalysisTopDomainCsvCreate = (
    data: PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopDomainCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/piracy/details/enf-analysis/top-domain/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsEnfAnalysisPiracy
   * @name PiracyDetailsEnfAnalysisTopChannelCsvCreate
   * @request POST:/performance/piracy/details/enf-analysis/top-channel/csv
   */
  piracyDetailsEnfAnalysisTopChannelCsvCreate = (
    data: PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopChannelCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/piracy/details/enf-analysis/top-channel/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsEnfAnalysisPiracy
   * @name PiracyDetailsEnfAnalysisTopAssetCsvCreate
   * @request POST:/performance/piracy/details/enf-analysis/top-asset/csv
   */
  piracyDetailsEnfAnalysisTopAssetCsvCreate = (
    data: PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetTopAssetCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/piracy/details/enf-analysis/top-asset/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags PerformanceDetailsEnfAnalysisPiracy
   * @name PiracyDetailsEnfAnalysisCsvCreate
   * @request POST:/performance/piracy/details/enf-analysis/csv
   */
  piracyDetailsEnfAnalysisCsvCreate = (
    data: PerfPiracyDetailPerfDetailsEnfAnalysisPiracyProtocolsGetListingsOverTimeCsvRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<MarqCommonProtocolFileResponse, any>({
      path: `/performance/piracy/details/enf-analysis/csv`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
